export enum UserType {
    EMPLEADO = 'EMPLEADO',
    EMPRESA = 'EMPRESA'
}
